export default "__VITE_ASSET__BxJmNVHJ__"